







































import { IMessage } from '@/store/messages'
import { CatchValidationErrorsMixin, UwInput } from '@ultraware/vee-form-handler'
import { QBtn, QCardActions, QSelect } from 'quasar'
import { ValidationObserver } from 'vee-validate'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { IVxsPromise } from 'vuex-xhr-state'

@Component({
  components: {
    QBtn,
    QSelect,
    UwInput,
    ValidationObserver,
    QCardActions,
  },
})

export default class MessageForm extends Mixins(CatchValidationErrorsMixin) {
  @Prop({ type: Object, required: true }) public prefill!: Partial<IMessage>
  @Prop({ type: Function, required: true }) public action!: (_: Partial<IMessage>) => IVxsPromise<void>
  public message = { ...this.prefill }

  @Watch('prefill')
  public updateMessage(): void {
    this.message = { ...this.prefill }
  }

  public cancel(): void {
    this.message = { ...this.prefill }
    this.$emit('close')
  }

  public submit(): void {
    this.$refs.validationObserver.validate()
      .then((result) => {
        if (!result) return

        this.action(this.message).then(() => {
          this.$emit('update')
          this.message = { ...this.prefill }
        }).catch(this.catchValidationErrors)
      })
  }
}
